import React from 'react';
import { Download, Eye, FileText, Image as ImageIcon, Paperclip, Trash2 } from 'lucide-react';

const formatBytes = (value) => {
  const size = Number(value || 0);
  if (!Number.isFinite(size) || size <= 0) return 'Unknown size';
  const units = ['B', 'KB', 'MB', 'GB'];
  let current = size;
  let index = 0;
  while (current >= 1024 && index < units.length - 1) {
    current /= 1024;
    index += 1;
  }
  return `${current >= 10 || index === 0 ? current.toFixed(0) : current.toFixed(1)} ${units[index]}`;
};

const fileIconForType = (contentType) => {
  const normalized = (contentType || '').toLowerCase();
  if (normalized.startsWith('image/')) return ImageIcon;
  if (normalized.includes('pdf') || normalized.startsWith('text/')) return FileText;
  return Paperclip;
};

function PromptAttachmentList({
  attachments = [],
  title = 'Attached Files',
  emptyLabel = 'No files attached yet.',
  allowDelete = false,
  onDelete = null,
  compact = false,
  stopPropagation = false
}) {
  if (!attachments.length) {
    return (
      <div className={`prompt-attachments ${compact ? 'compact' : ''}`}>
        <div className="prompt-attachments-header">
          <span>{title}</span>
        </div>
        <p className="text-xs text-gray-400">{emptyLabel}</p>
      </div>
    );
  }

  return (
    <div
      className={`prompt-attachments ${compact ? 'compact' : ''}`}
      onClick={stopPropagation ? (event) => event.stopPropagation() : undefined}
    >
      <div className="prompt-attachments-header">
        <span>{title}</span>
        <span className="text-xs text-gray-400">{attachments.length} file{attachments.length === 1 ? '' : 's'}</span>
      </div>
      <div className="prompt-attachment-list">
        {attachments.map((attachment) => {
          const Icon = fileIconForType(attachment.content_type);
          return (
            <div key={attachment.file_id} className="prompt-attachment-item">
              <div className="prompt-attachment-main">
                <div className="prompt-attachment-icon">
                  <Icon className="w-4 h-4" />
                </div>
                <div className="prompt-attachment-copy">
                  <div className="prompt-attachment-name">{attachment.name || 'Attachment'}</div>
                  <div className="prompt-attachment-meta">
                    <span>{attachment.content_type || 'Private file'}</span>
                    <span>{formatBytes(attachment.size_bytes)}</span>
                  </div>
                </div>
              </div>
              <div className="prompt-attachment-actions">
                {attachment.view_url && (
                  <a
                    className="icon-btn"
                    href={attachment.view_url}
                    target="_blank"
                    rel="noreferrer"
                    data-tooltip="View"
                    aria-label="View file"
                  >
                    <Eye className="w-4 h-4" />
                  </a>
                )}
                {attachment.download_url && (
                  <a
                    className="icon-btn"
                    href={attachment.download_url}
                    data-tooltip="Download"
                    aria-label="Download file"
                  >
                    <Download className="w-4 h-4" />
                  </a>
                )}
                {allowDelete && (
                  <button
                    type="button"
                    className="icon-btn danger"
                    onClick={() => onDelete?.(attachment)}
                    data-tooltip="Delete"
                    aria-label="Delete file"
                  >
                    <Trash2 className="w-4 h-4" />
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default PromptAttachmentList;
